import { Flex } from '@chakra-ui/react'

export const LeftAside = props => {
  return (
    <Flex direction='column' minWidth='41%' maxWidth='41%' mt='2rem' mb='2rem' mr='2rem'>
      {props.children}
    </Flex>
  )
}
